<template>
  <main>
    <NavBarItem />
    <router-view></router-view>
  </main>
</template>

<script>
export default {
  name: 'FrontProvider',
  components: {
    NavBarItem: () =>
      import('@/modules/FrontProvider/components/common/NavBarItem.vue'),
  },
};
</script>

<style lang="sass" scoped>
$breakpoint-sm: 768px

main
  padding: 4em 2em 2em
  display: grid
  grid-template-columns: 1fr
  grid-gap:  1em
  @media (max-width: $breakpoint-sm)
    padding: 2em 1em 1em
</style>
